import React from 'react'
import { connect } from 'react-redux'
import {
  Container,
} from 'semantic-ui-react'
import './index.css'
import ReveleerHeaderLogo from "../logos/ReveleerHeaderLogo";

function Vim(): JSX.Element {
  return (
    <Container>
      <div className="vim-container">
        <div className="logo">
          <ReveleerHeaderLogo />
        </div>
        <p className="vim-text">
          Your organization has enabled the Reveleer application to extract appointment data through your EHR session to identify and display care insights for select patient. No action is needed. Contact your practice admin if you have questions.
        </p>
      </div>
    </Container>
  )
}

export default connect()(Vim)